import { useSearchParams } from 'react-router-dom';

const usePlayrifstrom = () => {
  const [searchParams] = useSearchParams();
  const urlParamPlayrifstorm = searchParams.get('ref');
  const isParamPlayrifstorm = urlParamPlayrifstorm === 'playrifstorm';

  const handleCheckUrl = (url: string, haveParams?: boolean) => {
    const checkParams = haveParams
      ? `${haveParams}&ref=playrifstorm`
      : '?ref=playrifstorm';

    const defaultUrl =
      urlParamPlayrifstorm === 'playrifstorm' ? `${url}${checkParams}` : url;

    return defaultUrl;
  };

  const handleCheckUrlStorage = (url: string, haveParams?: boolean) => {
    const isPlayrifstrom = localStorage.getItem('ref');
    const checkParams = haveParams
      ? `${haveParams}&ref=playrifstorm`
      : '?ref=playrifstorm';

    const defaultUrl =
      isPlayrifstrom === 'playrifstorm' ? `${url}${checkParams}` : url;

    return defaultUrl;
  };

  const setStorageRifstrom = () => {
    return localStorage.setItem('ref', 'playrifstorm');
  };

  const removeStorageRifstrom = () => {
    return localStorage.removeItem('ref');
  };

  return {
    handleCheckUrl,
    isParamPlayrifstorm,
    handleCheckUrlStorage,
    setStorageRifstrom,
    removeStorageRifstrom
  };
};

export default usePlayrifstrom;
